<!-- 网站首页 -->
<template>
  <div class="index">
    <div class="navbar">
      <my-navbar class="navbarone"></my-navbar>
    </div>
    <div class="box_102">
      <div class="main">
        <img
          class="image_001"
          referrerpolicy="no-referrer"
          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPnge73d4969448c0c099997a3e563ebf3a5d02171a1afdf68465ddec07eff136eba"
        />
      </div>
      <div class="group_48 flex-col">
        <div class="block_1 flex-col"></div>
        <div class="ping block_2 flex-col" style="position:relative;">
          <img
            class="block_2"
            style="position:absolute;"
            :src="'api' + gaunyuList.tb_Rotation_img"
            alt=""
          />
          <span class="text_13"></span>
          <span class="text_14"></span>
          <div class="block_3 flex-col">
            <img
              style="width: 40px; height: 40px;margin: -40px 0 0 -222px; z-index:999"
              referrerpolicy="no-referrer"
              src=""
              onerror="this.style.display='none'"
            />
          </div>
          <!-- <div class="block_8 flex-row">
            <span class="text_14">开启留学新生活</span> -->
          <!-- </div> -->
          <!-- <swiper /> -->
          <!-- <div class="left buts" @click="lunbotuleft">＜</div> -->
          <div class="carousel1">
            <div class="rigth buts" @click="lunboturigth">＞</div>
            <div class="left buts" @click="lunbotuleft">＜</div>
          </div>
          <div class="lunbo">
            <div class="neirong buts">
              <div
                :style="{ transform: 'translateX(' + left + 'px)' }"
                v-for="(item, index) in shipinList"
                :key="index"
                @click="bofang('api' + item.tb_school_shiping)"
              >
                <div class="bofang">
                  <img
                    style="width: 55px; height: 55px"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng3aba8c9b29a6cf6c85274b78fc2b82e67cdaecceb12a5f43e739ce3e62329d37"
                  />
                  <span @click="details(item.tb_school_uuid)">
                    {{ item.name }}</span
                  >
                </div>
                <div class="tupian">
                  <img
                    :src="'api' + item.img"
                    alt=""
                    style="width: 100%; height: 80%"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="box_102">
      <div class="section_14 flex-col">
        <div class="group_51 flex-row">
          <div class="group_9 flex-row">
            <div class="image-text_69">
              <img
                class="label_5"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngeca39301217e0db712f9e77aa76c5df4c6f4ac7f7eba0c88417b5b23de81fb6f"
              />
              <span class="text-group_6">从区域搜索</span>
            </div>
          </div>
          <span class="text_15">エリアから検索</span>
        </div>
        <div class="block_6 flex-col"></div>
        <div class="group_52 flex-row justify-between">
          <div class="block_10 flex-col">
            <div style="width: 100%; height: 60px">
              <el-row>
                <el-col style="width: 270px; hight: 40px">
                  <el-input
                    type="text"
                    class="el-input"
                    prefix-icon="el-icon-search"
                    v-model="kb_content"
                    placeholder="搜索学院关键词"
                    style="width: 270px"
                    @keyup.enter.native="getAllKb"
                  ></el-input>
                </el-col>
              </el-row>
            </div>
            <div class="elemsousuo flex-col" @click="search(kb_content)">
              搜索
            </div>
            <div class="section_16 flex-col justify-end">
              <div class="section_16_beihai" @click="district('100')"></div>
              <div class="section_16_dongbei" @click="district('101')"></div>
              <div class="section_16_zhongbu" @click="district('109')"></div>
              <div class="section_16_guandong" @click="district('102')"></div>
              <div class="section_16_zhongguo" @click="district('105')"></div>
              <div class="section_16_dongjing" @click="district('103')"></div>
              <div class="section_16_jin" @click="district('107')"></div>
              <div class="section_16_siguo" @click="district('106')"></div>
              <!-- 测试 -->
              <div class="box_013 flex-col">
                <span class="text_036">全部地区学校数量</span>
                <span class="text_062">{{ count }}</span>
              </div>
              <!-- 测试 -->
              <div
                class="section_16_jiuzhou"
                @click="district('九州/冲绳地区')"
              ></div>
              <div class="text-wrapper_8 flex-col">
                <span class="text_17" @click="district('100')">北海道</span>
              </div>
              <div class="text-wrapper_9 flex-col">
                <span class="text_18" @click="district('109')">中部地区</span>
              </div>
              <div class="text-wrapper_10 flex-col">
                <span class="text_19" @click="district('103')">东京地区</span>
              </div>
              <div class="text-wrapper_11 flex-col">
                <span class="text_20" @click="district('107')"
                  >大阪/近畿地区</span
                >
              </div>
              <div class="text-wrapper_12 flex-col">
                <span class="text_21" @click="district('106')">四国地区</span>
              </div>
              <div class="text-wrapper_14 flex-col">
                <span class="text_42" @click="district('102')">关东地区</span>
              </div>
              <div class="text-wrapper_15 flex-col">
                <span class="text_43" @click="district('105')">中国地区</span>
              </div>
              <div class="text-wrapper_16 flex-col">
                <span class="text_44" @click="district('101')">东北地区</span>
              </div>
              <div class="text-wrapper_13 flex-col">
                <span class="text_22" @click="district('108')"
                  >九州/冲绳地区</span
                >
              </div>
            </div>
            <div class="section_17 flex-col"></div>
            <div class="image-text_71 flex-row justify-between">
              <img
                class="label_7"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng8f1422262c6a3b178bb6887997e8683380facac96a5763f714ef208ef6d7f412"
              />
              <div class="text-group_76 flex-col justify-between">
                <span class="text_23">热门关键词查找学校</span>
                <span class="text_24">人気キーワードで検索</span>
              </div>
            </div>
            <div class="box_53">
              <div
                class="group_11 flex-row buts"
                v-for="(item, index) in rmdqList"
                :key="index"
                @click="address(2, item)"
              >
                <span class="text_25">{{ item.tb_hxts_name }}</span>
                <img
                  class="thumbnail_2"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng29ade771a73f695fc133cda814764cc0a33eb61f04e1f14da46e6d3600a1b3a1"
                />
              </div>
            </div>
          </div>
          <div class="group_15 flex-col">
            <div class="group_16 flex-col">
              <div class="section_390">
                <div class="section_39 flex-row justify-between">
                  <div class="box_5 flex-col"></div>
                  <div class="text-group_77 flex-col justify-between">
                    <span class="text_32">话题学校</span>
                    <span class="text_33">話題学校</span>
                  </div>
                  <div class="box_6 flex-col"></div>
                </div>
              </div>
              <!-- <div
                class="group_070"
                v-for="(item, index) in huatixxList"
                :key="index"
              >
                <div class="group_18 clearfix">
                  <div class="text-group_78 ">
                    <span class="text_34">{{ item.name }}</span>
                  </div>
                  <div class="box_7 leftfix">
                    <img
                      :src="'api' + item.tb_school_img"
                      alt=""
                      style="height: 100%;width:150px;"
                    />
                  </div>
                  <div class="group_071">
                    <div class="jianjie ">{{ item.tb_school_jj }}</div>
                    <div class="group_19 ">
                      <span class="image-text_73buts">
                        <span
                          class="text-group_12 buts"
                          @click="browse(item.tb_school_uuid)"
                          >浏览
                        </span>
                        <img
                          class="thumbnail_10"
                          referrerpolicy="no-referrer"
                          src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng0ac5af2cb225940f78d5a9ec10caf7eb06710a52fb3a57bc144150e3da7a5764"
                        />
                      </span>
                    </div>
                  </div>
                </div>
                <div class="group_20 flex-col"></div>
              </div> -->
              <div class="group_070">
                <vue-seamless-scroll
                  :data="huatixxList"
                  :limitMoveNum="10"
                  style="height: 100%;"
                  class="warp"
                >
                  <ul class="item">
                    <li
                      v-for="(item, index) in huatixxList"
                      :key="index"
                      style="position: relative;"
                      @click="clickToView(item)"
                      class="buts"
                    >
                      <div class="group_18 clearfix">
                        <div class="text-group_78 ">
                          <span class="text_34">{{ item.name }}</span>
                        </div>
                        <div class="box_7 leftfix">
                          <img
                            :src="'api' + item.tb_school_img"
                            alt=""
                            style="height: 100%;width:150px;"
                          />
                        </div>
                        <div class="group_071">
                          <div class="jianjie ">{{ item.tb_school_jj }}</div>
                          <div class="group_19 ">
                            <span class="image-text_73buts">
                              <span
                                class="text-group_12 buts"
                                @click="browse(item.tb_school_uuid)"
                                >浏览
                              </span>
                              <img
                                class="thumbnail_10"
                                referrerpolicy="no-referrer"
                                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng0ac5af2cb225940f78d5a9ec10caf7eb06710a52fb3a57bc144150e3da7a5764"
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </li>
                  </ul>
                </vue-seamless-scroll>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="group_54 flex-col">
      <div class="box_101">
        <div class="box_10 flex-row">
          <div class="section_33 flex-col">
            <!-- <el-cascader-panel
              ref="meauTree"
              :options="yjlist"
              :props="opacity"
              @change="gotoschool"
            ></el-cascader-panel> -->
            <div class="block_14 flex-row justify-between">
              <div class="image-text_78 flex-row justify-between">
                <img
                  class="thumbnail_15"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng348523260fc09356f04cad318f45e29b4aff6140160499a364019478f66e672b"
                />
                <span class="text-group_21">按地区检索学校</span>
                <span class="text-group_211"
                  >(注，勾选要查看的地区，无需选择上级地区)</span
                >
              </div>
            </div>
            <el-cascader-panel
              ref="cascader"
              class="thumbnail_151"
              v-model="dd"
              :options="yjlist"
              :props="props"
              :collapse-tags="false"
              clearable
            ></el-cascader-panel>
            <el-button
              type="primary"
              style="width: 120px;height: 42px;background-color: rgba(230, 0, 33, 1); margin: 10px auto 0;"
              @click="looook"
              >查询学校</el-button
            >
            <!-- <div class="box_56 flex-row justify-between">
              <div class="image-text_105 flex-row justify-between">
                <img
                  class="thumbnail_42"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngf85ed2b150ff759986e099d81079b10c85aa5f8c65e9de0a47dedf346987882e"
                />
                <span class="text-group_48">城市</span>
              </div>
              <span class="text_47">市/区</span>
            </div>
            <div class="box_30 flex-col"></div>
            <div class="box_57 flex-row buts">
              <div
                v-for="(item, index) in csList"
                :key="index"
                class="image-text_106 flex-row justify-between"
              >
                <span class="text-group_49" @click="address(3)">{{
                  item.tb_address_name
                }}</span>
                <img
                  class="thumbnail_43"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngb035c44e0339b8b7cb20847055c81db1bafe6ad11c82384fabe0bfc3ea04773b"
                />
                <div class="group_37 flex-col"></div>
              </div>
            </div> -->
          </div>
          <div class="group_55 flex-col justify-between">
            <div class="box_11 flex-col">
              <div class="block_14 flex-row justify-between">
                <div class="image-text_78 flex-row justify-between">
                  <img
                    class="thumbnail_15"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngf85ed2b150ff759986e099d81079b10c85aa5f8c65e9de0a47dedf346987882e"
                  />
                  <span class="text-group_21">热门城市</span>
                </div>
                <!-- <span class="text_45">エリア</span> -->
              </div>
              <div class="box_13 flex-col"></div>
              <div class="block_15  buts">
                <div
                  v-for="(item, index) in dqList"
                  :key="index"
                  class="image-text_79 flex-row justify-between"
                >
                  <span class="text-group_22" @click="address(1, item)">{{
                    item.tb_address_name
                  }}</span>
                  <!-- <img
                    class="thumbnail_16"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng47575599c38b73b3ad6971f36b0b7aa011fe40dbef3a4baae47ad900fec99751"
                  /> -->
                  <div class="group_34 flex-col"></div>
                </div>
              </div>
            </div>
            <div class="box_16 flex-col">
              <div class="group_56 flex-row justify-between">
                <div class="image-text_88 flex-row justify-between">
                  <img
                    class="thumbnail_25"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc1e283b485a3ccc81aa174a65d2da30cd5e69db0e8ba73d565bd6be4770d7bba"
                  />
                  <span class="text-group_31">特色</span>
                </div>
                <!-- <span class="text_46">特色</span> -->
              </div>
              <div class="box_18 flex-col"></div>
              <div class="group_57 buts">
                <div
                  v-for="(item, index) in tsList"
                  :key="index"
                  class="image-text_89 flex-row justify-between"
                >
                  <span class="text-group_32" @click="address(2, item)">{{
                    item.tb_hxts_name
                  }}</span>
                  <!-- <img
                    class="thumbnail_26"
                    referrerpolicy="no-referrer"
                    src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng45a99783c298557d387736d7b42857a78a71dbd55feeb4f08a708207a59fb4ac"
                  /> -->
                  <div class="group_37 flex-col"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="box_102">
        <div class="text-group_83 flex-col justify-between">
          <span class="text_75">留学资讯</span>
          <span class="text_76">留学情報</span>
        </div>
        <div class="list_2 flex-row">
          <div
            @click.stop="information(item.tb_uuid)"
            class="list-items_1 flex-col"
            v-for="(item, index) in lxzxList"
            :key="index"
          >
            <div class="image-text_126 flex-col justify-between">
              <div class="section_34 flex-col">
                <img
                  :src="'api' + item.tb_home_img"
                  alt=""
                  style="height: 100%"
                  class="buts"
                />
              </div>
              <span class="text-group_70 buts" v-html="item.tb_title"></span>
            </div>
            <div class="box_67 flex-row justify-between">
              <div class="image-text_127 flex-row justify-between">
                <img
                  class="thumbnail_91 buts"
                  referrerpolicy="no-referrer"
                  src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPng3bac215d0f95247a3bfab3f4e03eec8faca134c3309c15d565590f4c08efe5ab"
                />
                <span class="text-group_71 buts">{{
                  (item.tb_add_time || "").split("T")[0]
                }}</span>
              </div>
              <div class="text-wrapper_17 flex-col">
                <span class="text_77 buts">查看</span>
              </div>
            </div>
          </div>
        </div>
        <div
          class="group_65 flex-row justify-between"
          v-for="(item, index) in loopData0"
          :key="index"
        >
          <div
            class="block_17 flex-col buts"
            @click.stop="information(item.tb_uuid)"
          >
            <div class="block_18 clearfix">
              <span class="text_94 leftfix">{{ item.tb_title }}</span>
              <div class="text-wrapper_22 leftfix">
                <span class="text_95 buts ">查看</span>
              </div>
            </div>
            <div class="text_96" v-html="item.tb_content"></div>
            <span class="text_97"
              >发布时间：{{ (item.tb_add_time || "").split("T")[0] }}</span
            >
          </div>
        </div>
      </div>
      <div style="width: 1380px; margin:20px auto 40px;">
        <div style="font-size: 30px;margin: 30px 0;">LINKS</div>
        <el-carousel :interval="4000"  height="60px" indicator-position="none" arrow="always" loop="false">
    <el-carousel-item v-for="(item, index) in imglist" :key="item">
      <div>        
        <img class="imglj" :src="item.url1" alt=""  @click="gotoxhs(item.name1)">
        <img class="imglj" :src="item.url2" alt=""  @click="gotoxhs(item.name2)">
        <img class="imglj" :src="item.url3" alt=""  @click="gotoxhs(item.name3)">
      </div>
    </el-carousel-item>
  </el-carousel>
      </div>
      <my_article></my_article>
      <my-footer class="navbarone"></my-footer>
    </div>
    <el-dialog :visible.sync="dialogVisible" :before-close="handleClose">
      <video
        style="width:100%;height:100%"
        :src="videoSrc"
        controls="controls"
        autoplay
        ref="videoL"
      >
        您的浏览器不支持 video 标签。
      </video>
    </el-dialog>
  </div>
</template>

<script>
import navbar from "../components/navbar/navbar.vue";
import footer from "../components/footer/footer.vue";
import article from "../components/article/article.vue";
import { GetIndex, GeRmAddress } from "../api/index";
import { GetSchool } from "../api/school";
import { GetSchoolCha } from "../api/schoolcha";
import { GetGuanyu } from "../api/guanyu";
import vueSeamlessScroll from "vue-seamless-scroll";
// import Slick from "vue-slick";
export default {
  components: {
    "my-navbar": navbar,
    "my-footer": footer,
    my_article: article,
    vueSeamlessScroll
    // Slick,
  },
  data() {
    return {
      shipinList: [],
      slickOptions: {
        slidesToShow: 1
      },
      list: Array(5)
        .fill()
        .map((_, i) => `/src/assets/logo.png`),
      loopData0: [],
      huatixxList: [],
      rmdqList: [],
      dqList: [], //地区
      tsList: [], //特色
      csList: [], //城市
      school_id: "", //学校详情ID
      lxzxList: [],
      sjlist: [],
      input: "",
      dialogVisible: false,
      videoSrc: "",
      kb_content: "", //搜索
      currentNav: "", // 跟踪当前菜单
      trap: "1",
      num: 0,
      left: 0,
      gaunyuList: {},
      yjlist: [],
      count: 0, //总数
      props: { multiple: true, checkStrictly: true },
      imglist:[
        {
          url1: require("@/assets/img/lj1.png"),
        name1: "https://www.kif-org.com",
          url2: require("@/assets/img/lj2.png"),
        name2: "https://www.jasso.go.jp",
          url3: require("@/assets/img/lj3.png"),
        name3: "https://www.jasso.go.jp/ryugaku/eju/index.html",
        },
        // {
        //  url4: require("@/assets/img/lj4.png"),
        // name4: "https://www.jlpt.jp/index.html"
        // }, 
        {
         url1: require("@/assets/img/lj5.png"),
        name1: "https://www.moj.go.jp/isa/about/region/tokyo/index.html",
         url2: require("@/assets/img/lj6.png"),
        name2: "http://jp.china-embassy.gov.cn/jpn/",
         url3: require("@/assets/img/lj7.png"),
        name3: "https://www.nhk.or.jp/lesson/ja/",
        },  {
          url1: require("@/assets/img/lj1.png"),
        name1: "https://www.kif-org.com",
          url2: require("@/assets/img/lj2.png"),
        name2: "https://www.jasso.go.jp",
          url3: require("@/assets/img/lj3.png"),
        name3: "https://www.jasso.go.jp/ryugaku/eju/index.html",
        },
        // {
        //  url4: require("@/assets/img/lj4.png"),
        // name4: "https://www.jlpt.jp/index.html"
        // }, 
        {
         url1: require("@/assets/img/lj5.png"),
        name1: "https://www.moj.go.jp/isa/about/region/tokyo/index.html",
         url2: require("@/assets/img/lj6.png"),
        name2: "http://jp.china-embassy.gov.cn/jpn/",
         url3: require("@/assets/img/lj7.png"),
        name3: "https://www.nhk.or.jp/lesson/ja/",
        }, 
      ],
      dd: []
    };
  },
  created() {
    this.getList();
    this.getguanyu();
    this.getschoolcha();
    this.$nextTick(() => {
      // 禁用右键
      document.oncontextmenu = new Function("event.returnValue=false");
      // 禁用选择
      document.onselectstart = new Function("event.returnValue=false");
    });
  },
  mounted() {},
  methods: {
    gotoxhs(name) {
      window.open(
        name
      );
    },
    demo() {
      setTimeout(() => {
        // 未选择过数据,默认展开第一行数据
        let data = this.$refs.cascader.menus;
        let child1 = data[0][3].children;
        let child2 = child1[0].children;
        let child3 = child2[0].children;
        let arr = [];

        data[0] && arr.push(data[0]);
        child1 && arr.push(child1);
        child2 && arr.push(child2);
        child3 && arr.push(child3);
        this.$refs.cascader.menus = arr;
      }, 10);
    },
    getschoolcha() {
      GetSchoolCha({}).then(response => {
        this.count = response.data.address_json.address_count;
        this.school_count = response.data.address_json;
      });
    },

    gotoschool(value) {
      console.log(value);
    },
    looook() {
      // let chooseArr = this.$refs.meauTree.getCheckedNodes();
      this.$router.push({
        name: "schoolCommon",
        params: {
          diqu: this.dd
        }
      });
    },
    bofang(item) {
      this.dialogVisible = true;
      this.videoSrc = item;
    },
    handleClose(done) {
      this.$nextTick(() => {
        const videoL = this.$refs.videoL;
        videoL.pause();
      });
      done();
    },
    //首页接口
    getList() {
      GetIndex().then(response => {
        this.sjlist = response.data.address_sj_data;
        let sjarr = this.sjlist.map(item => {
          return {
            code: item.tb_address_code.toString().slice(0, 3),
            label: item.tb_address_name,
            value: item.tb_address_code
          };
        });
        this.tsList = response.data.hxts_data; //特色
        this.csList = response.data.address_sj_data; //城市

        this.lxzxList = response.data.lxzx_data; //留学资讯
        this.loopData0 = response.data.tglxzx_data; //留学资讯
        this.rmdqList = response.data.hxts_rm_data; //热门关键词
        this.shipinList = response.data.shiping_data; //视频
      });
      GetSchool().then(response => {
        this.huatixxList = response.data; //话题
      });
      GeRmAddress({ rm: true }).then(response => {
        this.dqList = response.data; //城市
      });
      GeRmAddress({ is_tree: true }).then(response => {
        this.yjlist = response.data; //城市
        this.demo();
      });
    },
    //视频文字跳转学校详情
    details(id) {
      this.$router.push({
        path: "/schooldetails",
        query: { id }
      });
    },
    //话题浏览
    browse(id) {
      this.$router.push({
        path: "/schooldetails",
        query: { id }
      });
    },
    //地图框
    district(i) {
      // console.log(i);
      this.$router.push({
        path: "/schoolCommon",
        query: { address_value: i }
      });
    },
    //留学资讯
    information(id) {
      // console.log(id);
      let link = this.$router.resolve({ path: '/study', query: { studyid: id } });
      window.open(link.href, '_blank');
      // this.$router.push({
      //   path: "/study",
      //   query: { studyid: id }
      // });
    },
    //搜索
    search(kb_content) {
      this.$router.push({
        path: "/schoolCommon",
        query: { keywords: kb_content }
      });
    },
    //跳转地区
    address(trap, val) {
      // this.$router.push('/page/schoolCommon');
      if (trap == 1) {
        this.$router.push({
          name: "schoolCommon",
          query: {
            toschool: val.tb_address_code,
            diqu: "地区"
          }
        });
      } else if (trap == 2) {
        this.$router.push({
          name: "schoolCommon",
          query: {
            characteristic: val.tb_school_uuid,
            teg_key: "特色"
          }
        });
      }
    },
    lunbotuleft() {
      if (this.num == 0) {
        this.left = 0;
        return;
      }
      this.num++;
      this.left += 244;
    },
    lunboturigth() {
      if (this.num == -(this.shipinList.length - 6)) return;
      this.num--;
      this.left -= 244;
    },
    getguanyu() {
      GetGuanyu().then(response => {
        this.gaunyuList = response.data;
      });
    }
  }
};
</script>
<style src="../../static/css/index.css" scoped />

<style scoped>
.article {
  display: flex;
  justify-content: center;
}
.imglj{
  height: 60px;
  margin: 0 60px;
}
.link {
  display: flex;
  justify-content: center;
}
.elem {
  /* margin-left: -863px;
  margin-top: 30px; */
  /* cursor: pointer; */
}
/deep/ .el-cascader-menu__wrap {
  height: 400px;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.ping {
  width: 100%;
  margin: 0 auto;
  position: relative;
}
.carousel1 {
  position: relative;
  width: 1120px;
  margin: 0 auto;
}
.lunbo {
  /* position: absolute;
  top: 500px;
  left: 370px; */
  width: 1210px;
  /* height: 200px; */
  margin: 215px auto 0;
  /* background-color: rgba(225, 225, 225, 0.2); */
  overflow: hidden;
}

.left {
  width: 58px;
  height: 180px;
  font-size: 28px;
  color: rgba(255, 255, 255, 0.5);
  /* background-color: blue; */
  position: absolute;
  top: 225px;
  left: -110px;
  background-color: rgba(85, 83, 83, 0.104);
  text-align: center;
  line-height: 180px;
}
.left:hover {
  background-color: rgba(85, 83, 83, 0.404);
  color: #fff;
}
.rigth {
  width: 58px;
  height: 180px;
  font-size: 28px;
  color: rgba(255, 255, 255, 0.5);
  /* background-color: blue; */
  position: absolute;
  top: 225px;
  right: -100px;
  background-color: rgba(85, 83, 83, 0.104);
  text-align: center;
  line-height: 180px;
}
.rigth:hover {
  background-color: rgba(85, 83, 83, 0.404);
  color: #fff;
}
.neirong {
  list-style-type: none;
  min-width: 1200px;
  height: 200px;
  /* background-color: blue; */
  display: flex;
  overflow: hidden;
  /* justify-content: center; */
  justify-content: left;
  align-items: center;
  transform: 0.5s;
}
.neirong div {
  width: 224px;
  height: 180px;
  background-color: #fff;
  margin-right: 20px;
  position: relative;
}
.bofang {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
}
.bofang span {
  width: 150px;
  margin-top: 145px;
  z-index: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.bofang img {
  position: absolute;
  z-index: 1;
  top: 118px;
  left: 156px;
}
.tupian {
  width: 100%;
  height: 100%;
  position: absolute;
  top: -180px;
  left: 0;
}
.el-carousel__item:nth-child(2n) {
    background-color: #ffffff;
  }
  
  .el-carousel__item:nth-child(2n+1) {
    background-color: #ffffff00;
  }
/* ::v-deep .el-dialog__header ,.el-dialog__title{
  background-color: transparent;
  height: 100%;
}
::v-deep .el-dialog__headerbtn{
  position: absolute;
  top: 55px;
  right: 605px;
  font-size: 24px;
} */
</style>



// WEBPACK FOOTER //
// src/page/index.vue